export default {
  initial: {
    search: '',
  },
};
